import { useCallback, useEffect, useRef } from 'react';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import { setSearchOptionsEnabled } from 'store/cmaPropertySearch/cmaPropertySearchReducer';
import { getLatLongForAddress } from 'utils/getLatLong';
import useFormPropertyDetailsSelector from 'selectors/useFormPropertyDetailsSelector';
import useFormAddressSelector from 'selectors/useFormAddressSelector';
import { cleanFullAddress } from 'utils/formatAddress';

const ComparativeMarketAnalysisPreloader = () => {
  const dispatch = useAppDispatch();
  const searchNowEnabled = useAppSelector((state) => state.cmaPropertySearch.searchNowEnabled);
  const manualSearchEnabled = useAppSelector(
    (state) => state.cmaPropertySearch.manualSearchEnabled
  );

  const propertyDetails = useFormPropertyDetailsSelector();
  const propertyAddress = useFormAddressSelector();
  const propertyId = propertyDetails?.propertyId;
  const latitude = propertyDetails?.latitude;
  const longitude = propertyDetails?.longitude;
  const addressSearchText = cleanFullAddress(propertyAddress);
  const searchOptionsRef = useRef({ searchNowEnabled, manualSearchEnabled });

  useEffect(() => {
    searchOptionsRef.current = { searchNowEnabled, manualSearchEnabled };
  }, [manualSearchEnabled, searchNowEnabled]);

  const setSearchOptions = useCallback(
    (enabled: boolean) => {
      const currentSearchOptions = searchOptionsRef.current;

      if (
        currentSearchOptions.searchNowEnabled === enabled &&
        currentSearchOptions.manualSearchEnabled === enabled
      ) {
        return;
      }

      searchOptionsRef.current = {
        searchNowEnabled: enabled,
        manualSearchEnabled: enabled,
      };

      dispatch(
        setSearchOptionsEnabled({
          searchNowEnabled: enabled,
          manualSearchEnabled: enabled,
        })
      );
    },
    [dispatch]
  );

  const loadLatLong = useCallback(async () => {
    if ((latitude != null && longitude != null) || propertyId) {
      setSearchOptions(true);
      return;
    }

    try {
      const latLong = await getLatLongForAddress(addressSearchText);

      if (latLong?.latitude && latLong?.longitude) {
        setSearchOptions(true);
      } else {
        setSearchOptions(false);
      }
    } catch (error: any) {
      console.error(error);
      setSearchOptions(false);
    }
  }, [addressSearchText, latitude, longitude, propertyId, setSearchOptions]);

  useEffect(() => {
    loadLatLong();
  }, [loadLatLong]);

  return <></>;
};

export default ComparativeMarketAnalysisPreloader;
